<template>

  <div class="main_box">
    <!--    <div class="page_title">创建文章</div>-->

    <div class="content_box">
      <div class="left_form">
        <a-spin :spinning="formOption.busy">
          <a-form
              ref="form"
              :form="form"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 18 }"
          >

            <div class="form_title">文章设置</div>

            <a-row :gutter="24">
              <a-form-item label="是否外链">
                <a-switch
                    v-model="isHret"
                    @change="handleIsHretChange"
                />
              </a-form-item>
            </a-row>

            <a-row :gutter="24" v-if="!isHret">
              <a-form-item label="员工二维码">
                <a-switch
                    v-model="isEmployeeQrcode"
                    @change="handleIsEmployeeQrcodeChange"
                />
              </a-form-item>
            </a-row>

            <a-row :gutter="24">
              <a-form-item label="分类">
                <a-tree-select
                    v-decorator="['carTypeId',rules.carTypeId]"
                    allow-clear
                    :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
                    placeholder="请选择分类"
                    :treeData="treeData"
                    :replaceFields="{children:'children', title:'codeName', key:'codeId', value: 'codeId' }"
                >
                </a-tree-select>

                <!--                <a-select-->
                <!--                    :allowClear="true"-->
                <!--                    v-decorator="['carTypeId', rules.carTypeId]"-->
                <!--                    :options="carTypeOption">-->
                <!--                </a-select>-->
              </a-form-item>
            </a-row>

            <div v-if="isHret">
              <a-row :gutter="24">
                <a-form-item label="外链地址">
                  <a-input
                      v-decorator="['hretUrl', rules.hretUrl]"
                      placeholder="请输入外链地址"
                  />
                </a-form-item>
              </a-row>
            </div>

            <div>
              <a-row :gutter="24" v-if="this.isHret">
                <a-form-item label="文章标题">
                  <!--                  @input="handleTitleChange"-->
                  <a-input
                      v-decorator="['title']"
                      v-model="title"
                      :maxLength="50"
                      placeholder="最多输入50个字符..."
                  />
                </a-form-item>
              </a-row>
              <a-row :gutter="24" v-else>
                <a-form-item label="文章标题">
                  <!--                  @input="handleTitleChange"-->
                  <a-input
                      v-decorator="['title', rules.title]"
                      v-model="title"
                      :maxLength="50"
                      placeholder="最多输入50个字符..."
                  />
                </a-form-item>
              </a-row>

              <a-row :gutter="24" v-if="this.isHret">
                <a-form-item label="文章内容">
                  <!--                  @change="handleContentDetail"-->
                  <wangEdit
                      v-decorator="['contentDetail']"

                  ></wangEdit>
                </a-form-item>
              </a-row>
              <a-row :gutter="24" v-else>
                <a-form-item label="文章内容">
                  <!--                  @change="handleContentDetail"-->
                  <wangEdit
                      v-decorator="['contentDetail', rules.contentDetail]"

                  ></wangEdit>
                </a-form-item>
              </a-row>
            </div>

            <div class="form_title">文章分享设置</div>

            <a-row :gutter="24">
              <a-form-item label="分享标题">
                <a-input
                    v-decorator="['shareTitle', rules.shareTitle]"
                    :disabled="false"
                />
              </a-form-item>
            </a-row>

            <a-row :gutter="24">
              <div class="need pa">*</div>
              <a-form-item label="分享封面" class="pr">
                <!--                <uploader-->
                <!--                    :num="1"-->
                <!--                    v-decorator="['shareCoverImg', rules.shareCoverImg]"-->
                <!--                    :accept="'image/*'"-->
                <!--                    :url="api.temp.UPLOAD_TALK"-->

                <!--                >-->
                <!--                  &lt;!&ndash;                  @change="handleImgChange"&ndash;&gt;-->
                <!--                </uploader>-->
                <!--            新增 缩略图 2022/10/20-->
                <input style="display: none" ref="imgUploader" type="file" accept="image/*" @change="handleImgChange">

                <div class="img_uploader_box" @click="uploaderData" v-if="!this.shareCoverImg">
                  上传
                </div>
                <div class="upload_img" v-else @click="uploaderData">
                  <img :src="api.temp.FILE_PATH + shareCoverImg" alt="">
                </div>


                <span style="color: #999;">推荐尺寸160*180，支持jpg、png格式，不超过10M</span>
              </a-form-item>
            </a-row>

            <a-row :gutter="24">
              <a-form-item label="分享文案">
                <a-input
                    v-decorator="['shareDescribe', rules.shareDescribe]"
                    :maxLength="39"
                    :disabled="false"
                />
              </a-form-item>
            </a-row>

            <div class="label_box" v-if="!isHret">
              <!--            动态增加、减少项-->
              <a-row :gutter="24">
                <!--              <a-col :span="18">-->
                <a-form-item label="标签规则 客户"
                             :label-col="{ span: 4 }"
                             :wrapper-col="{ span: 18 }"
                >
                  <div v-for="(item,index) in labelList" :key="index" style="margin-bottom: 12px">
                    <div class="label_item_box">
                      <a-select
                          :allowClear="true"
                          v-model="item.ruleId"
                          :options="ruleIdOption"
                          style="height: 38px"
                      >
                      </a-select>
                      <p style="margin: 0 12px;line-height: 30px;">时</p>
                      <!--                      <a-select-->
                      <!--                          :allowClear="true"-->
                      <!--                          v-model="item.tagId"-->
                      <!--                          mode="multiple"-->
                      <!--                          :options="tagIdOption">-->
                      <!--                      </a-select>-->
                      <tagPicker v-model="item.tagId"></tagPicker>
                      <a-icon class="delete_icon" type="minus-circle" @click="delLabelRule(index)"/>
                    </div>
                  </div>
                </a-form-item>
                <!--              </a-col>-->
              </a-row>

              <a-row>
                <!--              <a-col :span="6">-->
                <!--                <a-button type="link" @click="addTag">新增</a-button>-->
                <!--                <a-button type="link" @click="refreshTag">刷新</a-button>-->
                <!--              </a-col>-->
                <a-button type="primary" style="margin: 0 auto 12px;display: block;" @click="addLabelRule">
                  <a-icon type="plus-circle"/>
                  添加标签规则
                </a-button>
              </a-row>

            </div>

            <a-row :gutter="24">
              <a-form-item label="是否全部可见">
                <a-switch
                    v-model="isAllVisible"
                    @change="handleIsAllVisibleChange"
                />
              </a-form-item>
            </a-row>

            <a-row :gutter="24" v-if="!isAllVisible">
              <a-form-item label="可见部门">
                <a-tree-select
                    v-decorator="['deptList',rules.deptList]"
                    allow-clear
                    show-search
                    tree-checkable
                    :dropdown-style="{ maxHeight: '300px', overflow: 'auto' }"
                    :tree-data="deptTreeList"
                    search-placeholder="请选择可见权限的部门"
                    :treeDefaultExpandAll="false"
                    :filterTreeNode="filterTreeNodeOption"
                    :treeDefaultExpandedKeys.sync="defaultExpandedKeys"
                    :replaceFields="{children:'children', title:'deptName', key:'deptId', value: 'deptId' }"
                    @change="handleDeptTree"
                >
                </a-tree-select>
              </a-form-item>
            </a-row>
          </a-form>
          <a-space class="a-form-btn-box" v-if="publishStatus == 0 || publishStatus == 2">
            <a-button @click="closePop">取消</a-button>
            <a-button type="primary" @click="_save">保存</a-button>
          </a-space>
          <!--          <a-modal-->
          <!--              title="新增关键词"-->
          <!--              :closable="true"-->
          <!--              :footer="null"-->
          <!--              :maskClosable="false"-->
          <!--              :visible="editModalVisible"-->
          <!--              @cancel="closeEdit"-->
          <!--              :width="600"-->
          <!--          >-->
          <!--            <detailForm :rowId="0"-->
          <!--                        v-if="editModalVisible"-->
          <!--                        ref="detailForm"-->
          <!--                        @cancelled="closeEdit()"-->
          <!--                        @saved="closeEdit(true)">-->
          <!--            </detailForm>-->
          <!--          </a-modal>-->
        </a-spin>
      </div>

      <!-- 预览 -->
      <div class="preview_box">

        <div class="form_title">页面预览</div>

        <div class="preview_phone">

          <div class="author_box" v-if="isEmployeeQrcode">
            <div class="left">
              <img class="header" src="@/assets/img/moren.png"/>
              <div class="name_box">
                <div class="name">员工姓名</div>
                <div class="company">公司名称</div>
              </div>
            </div>
            <div class="right">
              <span class="concat_me">联系我</span>
              <span class="more"><a-icon type="ellipsis"/></span>
            </div>
          </div>
          <div class="content_box">
            <p class="title">{{ title }}</p>
            <p class="time">{{ nowTime }}</p>
            <p
                class="content"
                v-html="contentDetail"
            >
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {formMixin, fmt, XEUtils} from '@/utils/common/FormBase'
import {pressImg} from '@/utils/common/compressImg'; //缩略图
// 接口
import {dataApi} from '@/services/market/marketManage.js';
import wangEdit from '@/components/editor/editor.vue';
import tagPicker from '@/components/picker/scrmTagPicker.vue';
import api from "@/services/api";


/**
 * 加载规则 必填控制我
 */
function getRulesTemplate() {
  return {
    title: {
      rules: [{required: true, message: "请输入文章标题"}],
    },

    contentDetail: {
      rules: [{required: true, message: "请输入文章内容"}],
    },

    shareTitle: {
      rules: [{required: true, message: "请输入分享标题"}],
    },
    shareCoverImg: {
      rules: [{required: true, message: "请上传分享封面"}],
    },
    shareDescribe: {
      rules: [{required: true, message: "请输入分享文案"}],
    },
    deptList: {
      rules: [{required: true, message: "请选择可见部门"}],
    },
    carTypeId: {
      rules: [{required: true, message: "请选择分类"}],
    },
    hretUrl: {
      rules: [{required: true, message: "请输入外链地址"}],
    }
  };
}

/**
 * 树选择搜索
 * */
function filterTreeNodeOption(input, treeNode) {
  return treeNode.data.props.title.includes(input)
}

/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad(entity) {
  const vm = this
  setTimeout(function () {
    vm.form.setFieldsValue({
      shareDescribe: entity.shareDescribe
    })
  }, 500)
}


/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {};
}


/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let res = await dataApi.getMarketFormDetail(rowId);
  let entity = {};
  if (res.data.entity.deptList) {
    res.data.entity.deptList = res.data.entity.deptList.split(',')
  }
  this.labelList = res.data.labelList;
  this.deptList = res.data.entity.deptList;
  // 开关赋值处理
  res.data.entity.isEmployeeQrcode = !!res.data.entity.isEmployeeQrcode;
  res.data.entity.isHret = !!res.data.entity.isHret;
  res.data.entity.isAllVisible = !!res.data.entity.isAllVisible;
  this.isEmployeeQrcode = res.data.entity.isEmployeeQrcode;
  this.isHret = res.data.entity.isHret;
  this.isAllVisible = res.data.entity.isAllVisible;
  this.title = res.data.entity.title;
  this.publishStatus = res.data.entity.publishStatus;
  this.carTypeId = res.data.entity.carTypeName
  this.shareCoverImg = res.data.entity.shareCoverImg //封面图
  this.thumbnail = res.data.entity.thumbnail//封面缩略图

  entity.data = res.data.entity;
  return fmt.formatFormLoad(entity);
}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities) {
  if (!this.shareCoverImg) {
    throw ('请上传分享封面')
  }
  //给主键赋值
  if (this.rowId) {
    entities.contentId = this.rowId;
  }
  entities.carTypeId = entities.carTypeName ? entities.carTypeName : entities.carTypeId; //分类
  entities.contentType = 1; // 1文章 2视频
  entities.isEmployeeQrcode = this.isEmployeeQrcode ? 1 : 0;
  entities.isHret = this.isHret ? 1 : 0;
  entities.isAllVisible = this.isAllVisible ? 1 : 0;
  // entities.contentDetail = this.contentDetail; //处理图片路径
  entities.shareCoverImg = this.shareCoverImg
  entities.thumbnail = this.thumbnail //缩略图
  let flag = true
  this.labelList.forEach((item, index) => {
    if (item.tagId) {
      item.tagId = item.tagId.toString()
    } else {
      flag = false
      throw (`请填写第${index + 1}项的标签`)
    }
  })
  if (flag) {
    let result = {
      entity: entities,
      labelList: this.labelList,
      deleteLabelList: this.deleteLabelList,
      deptList: entities.deptList ? entities.deptList : ''
    }
    console.log(415, result);
    await dataApi.saveFormDetail(result).then(res => {
      if (res.code === 200) {
        this.$emit('saved')
      }
    });
  }
}

/**
 * 加载基础数据
 */
async function loadBaseData() {
  // 新增功能 数结构选择分类 sxx 7-19
  let labelTreeData = await dataApi.getArticleTree();
  // 新增分类禁用 仅最后一级可选
  labelTreeData.data.forEach(item => {
    item.disabled = true
  })
  let treeData = XEUtils.toArrayTree(labelTreeData.data, {
    key: 'codeId',
    parentKey: 'parentId',
    children: 'children'
  });
  // 新增分类禁用 仅最后一级可选
  treeData.forEach(item => {
    if (item.children.length) {
      item.children.forEach(e => {
        if (e.children.length) {
          e.children.forEach(x => {
            x.disabled = false
          })
        }
      })
    }
  })

  this.treeData = treeData;

  let labelRuleData = await dataApi.getLabelRuleList();
  this.ruleIdOption = labelRuleData.data.CD400001.map(item => {
    return {
      title: item.code_name,
      key: item.code_id
    }
  })
  // 选择分类 原功能
  // this.carTypeOption = labelRuleData.data.CD400002.map(item => {
  //   return {
  //     title: item.code_name,
  //     key: item.code_id
  //   }
  // })
  let labelAllData = await dataApi.getLabelAllList();
  this.tagIdOption = labelAllData.data.map(item => {
    return {
      title: item.tagName,
      key: `${item.tagId}`
    }
  })
  let deptTreeList = await dataApi.getDeptList();
  this.deptTreeList = XEUtils.toArrayTree(deptTreeList.data, {
    key: 'deptId',
    parentKey: 'parentId',
    children: 'children'
  })

  // this.labelList = [{
  //   tagId: this.tagIdOption[0].tagId,
  //   ruleId: this.ruleIdOption[0].type_no
  // }]

  //默认所属部门只展开一级
  this.defaultExpandedKeys = this.deptTreeList.map(val => {
    // //默认只展开一级
    if (val.deptId === 1) { //已确定测试、正式系统最大一层deptId都是1
      return val.deptId
    }
  })
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  props: ['rowId'],
  components: {
    wangEdit, tagPicker
  },
  data() {
    return {
      mode: 'time',
      nowTime: XEUtils.toDateString(new Date(), 'yyyy-MM-dd HH:ss:mm'),
      title: '',
      contentDetail: '',
      isEmployeeQrcode: false,
      isAllVisible: false,
      shareTitle: '',
      ruleIdOption: [],
      // carTypeOption: [],
      treeData: [],
      tagIdOption: [],
      rightsOption: [],
      // labelList: [{
      //   tagId: '',
      //   ruleId: ''
      // }],
      labelListName: [],
      labelList: [],
      deleteLabelList: [], //更新时删除的
      deptTreeList: [],
      filterTreeNodeOption,
      defaultExpandedKeys: [],
      deptList: '',
      publishStatus: 0,
      isHret: false,
      hretUrl: '',
      coverImgFile: {},
      thumbnail: '',//封面图缩略图路径
      shareCoverImg: '',//封面图路径
    }
  },
  // mounted() {
  //   console.log(compressImg.pressImg({}));
  // },
  watch: {},
  // created() {
  //   this.loadBaseData();
  //   if(this.rowId){
  //     this.loadEntity(this.rowId)
  //   }
  // },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    afterLoad,
    loadBaseData,
    /**
     *自定义样式调用input事件
     */
    uploaderData() {
      this.$refs['imgUploader'].dispatchEvent(new MouseEvent('click'))
    },
    // todo INPUT缩略图
    handleImgChange() {
      let file = this.$refs['imgUploader'].files[0] //获取文件流
      // console.log(file)
      const vm = this
      vm.getImgUpload(file, 'img') //传给接口
      pressImg({ //进行压缩
        file: file,
        width: 130,
        height: 130,
        success(resultFile) {
          vm.getImgUpload(resultFile, 'pressImg') //压缩后图片再次上传接口
        }
      })
    },
    /**
     *图片上传
     * @param file 文件流
     * @param type 具体分类 用于判别给哪个字段赋值
     */
    async getImgUpload(file, type) {
      let formData = new FormData();
      formData.append('file', file);
      let url = api.temp.UPLOAD_TALK //图片上传接口
      let urlData = await fetch(url, { //通过fetch上传文件流
        method: 'post',
        body: formData
      }).then(res => {
        return res.json()
      })
      if (type == 'img') {
        this.shareCoverImg = urlData.data.url //未压缩图片
      } else {
        this.thumbnail = urlData.data.url //已压缩图片
      }
      // console.log(type, urlData.data.url)
      // console.log(this.shareCoverImg);
      // console.log(this.thumbnail);
    },
    handleDeptTree(value) {
      console.log('handleDeptTree', value)
    },
    closePop() {
      this.$emit('cancelled');
    },
    handleOpenChange(open) {
      if (open) {
        this.mode = 'time';
      }
    },
    handlePanelChange(value, mode) {
      this.mode = mode;
    },
    refreshTag() {
      this.loadBaseData()
    },
    addTag() {
      this.editModalVisible = true
    },
    closeEdit() {
      this.editModalVisible = false
    },
    addLabelRule() { // 新增标签规则
      this.labelList.push({
        tagId: this.tagIdOption[0].tagId,
        ruleId: this.ruleIdOption[0].type_no
      });
    },
    delLabelRule(index) { // 删除标签规则
      console.log('index', index);
      if (this.labelList.length <= 1) {
        this.$message.error('已经是最后一条标签规则了')
        return false
      }
      let tagRuleId = this.labelList[index].tagRuleId;
      if (tagRuleId) {
        this.deleteLabelList.push(tagRuleId);
      }
      this.labelList.splice(index, 1)
      console.log('labelList', this.labelList)
      this.$forceUpdate();
      console.log('deleteLabelList', this.deleteLabelList);
    },
    handleIsAllVisibleChange(value) {
      this.isAllVisible = value;
    },
    handleIsEmployeeQrcodeChange(value) {
      this.isEmployeeQrcode = value;
    },
    handleIsHretChange(value) {
      this.isHret = value;
    },
    // 去除富文本的标签只获得文本内容
    removeTag(str) {
      let fn_result = str;
      fn_result = fn_result.replace(/(↵)/g, "");
      fn_result = fn_result.replace(/\s*|\t|\r|\n/g, "");// 去除tab、空格、空行(会去掉图片和字体颜色样式)
      fn_result = fn_result.replace(/(&nbsp;)/g, "");
      // fn_result = fn_result.replace(/<\/?p>|<\/?b>|<\/?img>|<\/?span>|<\/?a>|<\/?ul>|<\/?li>|<\/?i>*/gi, "");
      fn_result = fn_result.replace(/<[^>]+>/g, "");
      fn_result = fn_result.replace("<html><head><title></title></head><body>", "");
      fn_result = fn_result.replace("</body></html>", "");
      console.log(fn_result.length)
      return fn_result;
    },
    handleContentDetail(value) {
      // /gateway/BASE-SERVE/sys/oss/local/upload 企微端富文本图片不显示问题
      // value.replace(/\/gateway\/BASE-SERVE\/sys\/oss\/local\/upload/g,location.origin + '/gateway/BASE-SERVE/sys/oss/local/upload');
      this.contentDetail = value;
      var content = this.removeTag(value).substring(0, 38);
      this.form.setFieldsValue({
        shareDescribe: content
      })
    },
    handleTitleChange($event) {
      this.title = $event.target.value;
      // 修改v-decorator的值
      this.form.setFieldsValue({
        shareTitle: this.title
      })
    },
  }
};
</script>

<style scoped lang="less">
//分享封面样式

.img_uploader_box {
  width: 104px;
  height: 104px;
  margin-right: 8px;
  margin-bottom: 8px;
  text-align: center;
  line-height: 104px;
  vertical-align: top;
  background-color: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
}

.upload_img {
  width: 104px;
  height: 104px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.need {
  display: inline-block;
  margin-right: 4px;
  color: #f5222d;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
  left: 37px;
  top: 13px;
}

.is_required::before {
  display: inline-block;
  margin-right: 4px;
  color: #f5222d;
  font-size: 14px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: '*';
}

/deep/ .vxe-toolbar {
  height: 10px;
}

.main_box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.content_box {
  display: flex;
  justify-content: space-between;
}

.a-form-btn-box {
  display: flex;
  justify-content: center;
}

.left_form {
  width: calc(100% - 400px);
}

.preview_box {
  width: 400px;
  height: 100%;
  padding: 0 20px;
  overflow-y: hidden;

  .preview_phone {
    width: 375px;
    height: 667px;
    margin: 20px auto;
    background-image: url("../../../../assets/img/market_phone_bg.png");
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    padding: 50px 54px;

    .author_box {
      display: flex;
      justify-content: space-between;

      .left {
        display: flex;
        justify-content: flex-start;

        .name_box {
          align-self: center;
        }

        .header {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          margin: 0 12px 0 0;
        }

        .name {
          font-size: 16px;
          font-weight: bold;
          color: #333;
        }

        .company {
          font-size: 14px;
          color: #999;
        }
      }

      .right {
        align-self: center;

        .concat_me {
          padding: 3px 10px;
          background: #E9F5FC;
          border-radius: 12px;
          font-size: 12px;
          color: #48A7FB;
          text-align: center;
          line-height: 30px;
          margin-right: 8px;
        }

        .more {
          color: #333;
          font-size: 20px;
          font-weight: bold;
        }
      }
    }

    .content_box {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      padding-top: 6px;

      .title {
        line-height: 40px;
        color: #333;
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 0;
      }

      .time {
        color: #999;
        font-size: 12px;
        margin-bottom: 12px;
      }

      .content {
        color: #666;
        font-size: 14px;
        margin-bottom: 0;
        overflow-y: auto;
        overflow-x: hidden;
        height: 440px;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
}

.label_item_box {
  display: flex;
  justify-content: space-around;
}

.delete_icon {
  cursor: pointer;
  font-size: 16px;
  line-height: 35px;
  display: inline-block;
  margin-left: 12px;
}

/deep/ .ant-modal-body {
  padding: 0 24px !important;
}

///deep/.editor_box{
//  height: 200px;
//}

</style>
